import axios from 'axios';

const api = axios.create({
  baseURL: 'https://stqa.softye.cloud/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// ===============================
// REQUEST INTERCEPTOR (TOKEN)
// ===============================
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['authorization'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ===============================
// RESPONSE INTERCEPTOR (401)
// ===============================
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      //  Clear session
      localStorage.removeItem('token');

      //  Redirect to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
